import registerBootstrapVuePlugins from 'src/config/setup/plugins/bootstrap.js'
import registerOtherPlugins from 'src/config/setup/plugins/others.ts'
import registerSduiPlugins from 'src/config/setup/plugins/sdui.js'
import './extensions/index.js'

export default function registerPlugins(app) {
  registerBootstrapVuePlugins(app)
  registerOtherPlugins(app)
  registerSduiPlugins(app)
}
